var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRightarrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15,
    height: 10,
    viewBox: "0 0 15 10",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.6425 4.42922L10.0712 0.28623C9.77689 -0.0647626 9.19515 -0.0960337 8.85385 0.20948C8.51256 0.514991 8.47813 1.09783 8.79447 1.42912L12.098 4.1435H0.857137C0.383753 4.1435 0 4.52728 0 5.00067C0 5.47408 0.383753 5.85783 0.857137 5.85783H12.098L8.79447 8.57222C8.47813 8.90351 8.52091 9.48528 8.8622 9.7908C9.2035 10.0963 9.77689 10.0661 10.0712 9.7151L14.6425 5.57211C14.941 5.1563 14.9172 4.783 14.6425 4.42922Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightarrow);
export default __webpack_public_path__ + "static/media/rightarrow.7d3d28060a76da9677d1be4d4bd76a9a.svg";
export { ForwardRef as ReactComponent };